import SubHeader from "../../components/header/SubHeader";
import FilterOrders from "../../components/order/FilterOrders";
import OrderList from "../../components/order/OrderList";
import { Role } from "../../enums/enums";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
    fetchOrders,
    // resetCreateStatus, resetFetchCustomerStatus,
    // resetUpdatePaymentStatus,
    // resetUpdateStatus,
    // updateOrderPayment,
    fetchOrdersByFilter
} from "../../store/order-slice";
import { useEffect } from "react";

const NewOrders = () => {
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const timezone = 'Asia/Kolkata';
    const {
        items,
        fetchStatus,
        // createStatus,
        // updateStatus,
        // fetchCustomerStatus,
        // updatePaymentStatus,
        // error
    } = useSelector((state) => state.order);
    useEffect(() => {
        dispatch(fetchOrders(userRole));
    }, [dispatch, userRole]);
    return (
        <div>
            <SubHeader title="New Orders"/>
            <div className="container m-0 p-0">
                            {userRole.role !== Role.Employee && <FilterOrders fetchOrders={fetchOrders} fetchOrdersByFilter={fetchOrdersByFilter} />}
                            <div className="row">
                                <div className="col-12">
                                    {fetchStatus === "success" && <OrderList
                                        items={items.filter(item => item.orderStatus === 0)}
                                        userRole={userRole}
                                        timezone={timezone}
                                        // formData={formData}
                                        // onOrderUpdate={updateOrderHandler}
                                    />}
                                </div>
                            </div>
                        </div>
        </div>
    );
}

export default NewOrders;